export default theme => ({
    button:{
        backgroundColor:"rgb(3, 169, 244)",
        color:"white",
        
    },
    refreshButton:{
        width:"100%"
        
    }
  });
  
  


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/ControlMonthObjective/WindowModalMonthDelete/styles.jsx